import React from 'react';
import { Link } from 'react-router-dom';

import moment from 'moment';

import { SearchAlienationFourriereWarningDto } from 'lib_api/lib/api/gen';

import { ColumnProps } from 'components/WrappedComponents/Table/types';
import { FluxDisplayName } from 'enums/flux/FluxDisplayName';
import { DATE_FORMAT } from 'utils/formats';

import DashboardWarningsAlienation from '../../../shared/components/DashboardWarningsAlienation';

function DashboardWarningsLieuxDepot(): React.ReactElement {
  function buildDossierLink(
    data: SearchAlienationFourriereWarningDto,
  ): React.ReactElement {
    return (
      <Link to={`/admin/dossier/${data.id}`} className={'dossierLink'}>
        {data.id}
      </Link>
    );
  }

  function buildAdditionalColumns(): ColumnProps<SearchAlienationFourriereWarningDto>[] {
    return [
      {
        title: 'Id dossier',
        buildCellContent: data => buildDossierLink(data),
      },
      {
        title: "Date de l'appel",
        buildCellContent: data =>
          data.dateAppel ? moment(data.dateAppel).format(DATE_FORMAT) : '',
      },
    ];
  }
  return (
    <DashboardWarningsAlienation
      getControllerFunctionFetchFlux={controller =>
        controller.getSpecificFluxFourriereUsingGET.bind(controller)
      }
      getControllerFunctionFetchWarnings={controller =>
        controller.searchWarningsFluxFourriereUsingGET.bind(controller)
      }
      buildSpecificTableColumns={buildAdditionalColumns}
      tableTitle={FluxDisplayName.ALIENATION_FOURRIERE}
    />
  );
}

export default DashboardWarningsLieuxDepot;
